import React, { useState } from "react";
import {
  FaArrowDown,
  FaUser,
  FaBuilding,
  FaPhone,
  FaEnvelope,
  FaQuestionCircle,
  FaGlobeAsia,
} from "react-icons/fa";

const FreeAuditPage = () => {
  const [formData, setFormData] = useState({
    companyName: "",
    fullName: "",
    phoneNumber: "",
    email: "",
    question: "",
    website: "",
    isFreeAudit: "YES",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("sending form data: ", JSON.stringify(formData));
      const response = await fetch("https://hook.us2.make.com/nfx57rsdoclgmj5tjpt1lv2ndq95o7fg", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("Thank you! We'll be in touch soon.");
        setFormData({
          companyName: "",
          fullName: "",
          phoneNumber: "",
          email: "",
          question: "",
          website: "",
          isFreeAudit: "YES",
        });
      } else {
        setStatus("An error occurred. Please try again later.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setStatus("An error occurred while submitting. Please try again later.");
    }
  };

  return (
    <div className="flex items-center justify-center bg-gray-100 px-4 py-12">
      <div className="bg-white shadow-lg rounded-lg max-w-3xl w-full p-8 md:p-12">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-black mb-4">
          Skip the guesswork. <br /> Right strategy is important to grow your
          business!
        </h2>
        <p className="text-center text-black mb-8">
          Do you want to know how we can help you?
          <br /> Fill out the form and we will contact you within 48 hours for
          a free analysis.
          <br />
          No costs, no obligations, no annoying sales pitch. Guaranteed!
        </p>

        {/* Arrow with animation */}
        <div className="flex justify-center mb-4 animate-bounce">
          <FaArrowDown className="text-blue-600 text-3xl" />
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative">
              <FaUser className="absolute left-3 top-4 text-blue-600" />
              <input
                type="text"
                name="fullName"
                placeholder="Full Name"
                value={formData.fullName}
                onChange={handleChange}
                className="w-full pl-10 p-3 border-2 border-gray-200 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-blue-600"
                required
              />
            </div>
            <div className="relative">
              <FaEnvelope className="absolute left-3 top-4 text-blue-600" />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                className="w-full pl-10 p-3 border-2 border-gray-200 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-blue-600"
                required
              />
            </div>
            <div className="relative">
              <FaBuilding className="absolute left-3 top-4 text-blue-600" />
              <input
                type="text"
                name="companyName"
                placeholder="Company Name"
                value={formData.companyName}
                onChange={handleChange}
                className="w-full pl-10 p-3 border-2 border-gray-200 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-blue-600"
                required
              />
            </div>
            <div className="relative">
              <FaPhone className="absolute left-3 top-4 text-blue-600" />
              <input
                type="tel"
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleChange}
                className="w-full pl-10 p-3 border-2 border-gray-200 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-blue-600"
                required
              />
            </div>
            <div className="md:col-span-2 relative">
              <FaQuestionCircle className="absolute left-3 top-4 text-blue-600" />
              <input
                type="text"
                name="question"
                placeholder="What is your most important question?*"
                value={formData.question}
                onChange={handleChange}
                className="w-full pl-10 p-3 border-2 border-gray-200 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-blue-600"
                required
              />
            </div>
            <div className="md:col-span-2 relative">
              <FaGlobeAsia className="absolute left-3 top-4 text-blue-600" />
              <input
                type="text"
                name="website"
                placeholder="What is your website address?"
                value={formData.website}
                onChange={handleChange}
                className="w-full pl-10 p-3 border-2 border-gray-200 rounded-md text-black focus:outline-none focus:ring-2 focus:ring-blue-600"
              />
            </div>
          </div>
          <div className="flex items-center mt-4">
            <input
              type="checkbox"
              required
              className="form-checkbox text-blue-600 h-5 w-5"
            />
            <span className="ml-2 text-black text-sm">
              I agree to the privacy policy
            </span>
          </div>
          <button
            type="submit"
            className="w-full py-3 text-lg font-semibold text-white bg-blue-600 rounded-md shadow-lg hover:bg-blue-700 transition-opacity"
          >
            SEND
          </button>
        </form>
        {status && <p className="mt-6 text-center text-green-500">{status}</p>}
      </div>
    </div>
  );
};

export default FreeAuditPage;
